'use client';

import { ReactNode } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { RegularInfo } from '../../../common/svgIcons';

export const sectionLabelStyles = css({
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  lineHeight: 'caption.small',
  letterSpacing: 'caption.small',
  color: 'neutrals.text_secondary',
  width: '100%',
});

const iconBoxStyles = css({
  border: '1px solid',
  borderColor: 'neutrals.stroke_secondary',
  borderRadius: '4px',
  height: '24px',
  width: '35px',
  padding: 'extra_small_3',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

const paymentMethodNameStyles = css({
  fontSize: 'label.medium_medium',
  fontWeight: 'label.medium_medium',
  lineHeight: 'label.medium_medium',
  letterSpacing: 'label.medium_medium',
  color: 'neutrals.text_primary',
  whiteSpace: 'nowrap',
});

const paymentAmountStyles = css({
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
  letterSpacing: 'caption.medium_medium',
  color: 'neutrals.text_secondary',
  textAlign: 'end',
  whiteSpace: 'nowrap',
  flexShrink: 0,
});

export const PaymentMethodRow = ({
  icon,
  name,
  amount,
  onClick,
}: {
  icon: ReactNode;
  name: string;
  amount?: string;
  onClick?: () => void;
}) => (
  <div
    className={css({
      display: 'flex',
      gap: 'extra_small_3',
      height: '24px',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      cursor: onClick ? 'pointer' : 'default',
    })}
    onClick={onClick}
  >
    <div
      className={css({
        display: 'flex',
        flex: '1 0 0',
        gap: 'extra_small',
        alignItems: 'center',
        minWidth: 0,
      })}
    >
      <div className={iconBoxStyles}>{icon}</div>
      <div
        className={css({
          display: 'flex',
          gap: 'extra_small_2',
          alignItems: 'center',
          flexShrink: 0,
        })}
      >
        <span className={paymentMethodNameStyles}>{name}</span>
        <RegularInfo size={10} color="neutrals.text_primary" />
      </div>
    </div>
    {amount && <span className={paymentAmountStyles}>{amount}</span>}
  </div>
);
